import React from 'react'

import styled from 'styled-components'
import { DownOutlined } from '@ant-design/icons'

interface SectionProps {
  title: string;
  children: React.ReactNode;
  collapsible?: boolean;
  defaultCollapsed?: boolean;
}

const SectionContainer = styled.div`
  margin-bottom: 24px;
`

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  cursor: pointer;
`

const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  flex-grow: 1;
`

const CollapseIcon = styled(DownOutlined)<{ $isCollapsed: boolean }>`
  transform: rotate(${(props) => (props.$isCollapsed ? 0 : 180)}deg);
  transition: transform 0.3s;
  font-size: 12px;
  color: #8c8c8c;
`

const SectionContent = styled.div<{ $isCollapsed: boolean }>`
  display: ${(props) => (props.$isCollapsed ? 'none' : 'block')};
`

export const Section: React.FC<SectionProps> = ({
  title,
  children,
  collapsible = false,
  defaultCollapsed = false,
}) => {
  const [isCollapsed, setIsCollapsed] = React.useState(defaultCollapsed)

  const toggleCollapse = () => {
    if (collapsible) {
      setIsCollapsed(!isCollapsed)
    }
  }

  return (
    <SectionContainer>
      <SectionHeader onClick={toggleCollapse}>
        <SectionTitle>
          {title}
        </SectionTitle>

        {collapsible && <CollapseIcon $isCollapsed={isCollapsed} />}
      </SectionHeader>

      <SectionContent $isCollapsed={isCollapsed}>
        {children}
      </SectionContent>
    </SectionContainer>
  )
}